import API from 'services/API';

export default function getIncomeInformations() {
  return API.request({
    method: 'GET',
    url: '/taxpayer/incomeData/v2',
    mapper: function (responseData) {
      return responseData.map((item) => {
        item.companyName = item.companyName ? item.companyName.replace(/,+/g, ' ') : '';
        return item;
      });
    },
  });
}
